import React from 'react';
import { Button } from '@material-ui/core';

function CustomerBulkTemplateDownload({ csvColumns, fileName }) {
    return (
        <Button
            onClick={() => {
                const csvContent = `data:text/csv;charset=utf-8,${csvColumns}`;
                const encodedUri = encodeURI(csvContent);
                const link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute('download', `${fileName}_template.csv`);
                document.body.appendChild(link);

                link.click();
            }}
        >
            Download Template
        </Button>
    );
}

export { CustomerBulkTemplateDownload };
